import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useWorkspace } from "@/context/WorkspaceContext";

export function SicPicker({ value, onChange }) {
  const { api } = useWorkspace();
  const [q, setQ] = useState("security");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const id = setTimeout(() => api.get("/stage1/sic-codes", { params: { q } }).then(({ data }) => setRows(data)).catch(() => setRows([])), 250);
    return () => clearTimeout(id);
  }, [api, q]);
  const flip = (r) => onChange(value.some((v) => v.code === r.code) ? value.filter((v) => v.code !== r.code) : [...value, r]);
  return (
    <div className="space-y-2" data-testid="sic-picker">
      <div className="flex flex-wrap gap-1.5" data-testid="sic-selected">
        {value.length === 0 && <span className="text-xs text-muted-foreground">No trade codes chosen yet</span>}
        {value.map((v) => (
          <span key={v.code} className="inline-flex items-center gap-1 rounded-full border border-primary/40 bg-primary/10 px-2 py-0.5 text-xs">
            <b className="font-mono">{v.code}</b> {v.description}
            <button type="button" aria-label="Remove" onClick={() => flip(v)} data-testid={`sic-remove-${v.code}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input className="pl-8" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search trade codes, e.g. security, electrical, 80200" data-testid="sic-search-input" />
      </div>
      <div className="max-h-56 overflow-y-auto rounded-md border" data-testid="sic-table">
        <table className="w-full text-sm">
          <tbody>
            {rows.map((r) => (
              <tr key={r.code} className="cursor-pointer border-b border-border/60 hover:bg-accent/50" onClick={() => flip(r)} data-testid={`sic-row-${r.code}`}>
                <td className="w-8 px-2 py-1.5"><input type="checkbox" readOnly checked={value.some((v) => v.code === r.code)} className="h-4 w-4 accent-[hsl(var(--primary))]" /></td>
                <td className="w-16 py-1.5 font-mono text-xs">{r.code}</td>
                <td className="py-1.5 pr-2">{r.description}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td className="p-3 text-xs text-muted-foreground">No matching trade codes</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
